import React, {useContext, useEffect, useState} from "react";
import {IAssistantContext} from "../dependencies/interfaces/IAssistantContext";
import AppContext, {IAppV2Context} from "../../../componentsApp/context/AppContext";
import Spaces from "../../../sharedComponents/components/Spaces";
import {ButtonBack} from "../../../sharedComponents/components/Buttons/ButtonBack";

export default (props: IAssistantContext) => {
  
  const appContextV2: IAppV2Context = useContext(AppContext) as IAppV2Context;
  
  return (<section>
    
    <Spaces n={0}/>
    
    <div className={"assistant--v2-container--no-flex"}>
      <div className={"space-light"}>
        <ButtonBack back={() => props.wizard.previousStep()}/>
      </div>
    </div>
    
    <div className={"assistant--v2-title"}>
      Le poste est-il en télétravail* ?
    </div>
    
    <Spaces n={1}/>
    
    <div className={"assistant--v2-container"}>
      
      <button className={"btn-assistant-main"}
              onClick={() => {
                props.updateForm()({target: {type: "custom", name: "cvMandatory", value: true}});
                props.wizard.goToStep('lastAssistantStep');
              }}>
        Oui, le poste est en télétravail
      </button>
      
      <button className={"btn-assistant-main"}
              onClick={() => {
                props.updateForm()({target: {type: "custom", name: "cvMandatory", value: false}});
                props.wizard.goToStep('roaming');
              }}>
        Non, la présence du candidat est la norme
      </button>
    
    </div>
    
    <Spaces n={1}/>
    
    <div className={"text--center text--grey assistant--v2-container--no-flex"}>
      * Hors période de confinement forcé liée au COVID. Si des jours de travail sont proposés de temps en temps, vous pouvez l'ajouter aux <button className={"btn--hollow modern-link"} onClick={()=>props.wizard.goToStep('advantages')}>avantages</button>.
    </div>
  
  </section>);
}